<template>
  <div class="confirm-dialog">
    <el-dialog
      ref="dialog"
      class="custom-dialog"
      :visible.sync="visible"
      :width="width + '%'"
      :close-on-click-modal="false"
    >
      <div slot="title" class="header">
        <span class="title">{{ title }}</span>
        <div class="header-ops">
          <slot name="buttons"></slot>
          <div class="op confirm" @click="confimClick" v-if="!loading">
            <svg-icon icon-class="check" class="op-icon" />
            <span>Confirm</span>
          </div>
          <div class="op close" @click="cancelClick">
            <svg-icon icon-class="close" class="op-icon" />
            <span>Cancel</span>
          </div>
        </div>
      </div>
      <div class="content" v-loading="loading">
        <div class="error-msg" v-if="errMsg !== ''">
          <el-alert :title="errMsg" type="error" :closable="false" />
        </div>
        <slot name="content"></slot>
      </div>
      <div class="footer f-r">
        <slot name="footer-ops"></slot>
        <el-button
          type="primary"
          size="small"
          @click="confimClick"
          :loading="loading"
        >
          Confirm
        </el-button>
        <el-button type="danger" size="small" @click="cancelClick">
          Cancel
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
export default {
  name: 'ConfirmDialog',
  mixins: [dialogMixin],
  components: {},
  props: {
    title: {
      type: String,
      default: 'Confirm'
    },
    width: {
      type: Number,
      default: 30
    },
    confirmCb: {
      type: Function,
      default: () => {}
    },
    cancelCb: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      errMsg: ''
    }
  },
  methods: {
    saveCb() {
      //
    },
    open() {
      this.errMsg = ''
      this.visible = true
    },
    close() {
      this.errMsg = ''
      this.visible = false
    },
    error(msg) {
      this.errMsg = msg
    },
    confimClick() {
      this.errMsg = ''
      this.confirmCb(this.close, this.error)
    },
    cancelClick() {
      this.errMsg = ''
      this.cancelCb()
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.header {
  .title {
    font-size: $title-level-three;
    font-weight: bold;
  }

  .header-ops {
    gap: 10px;

    @extend .f-r;

    .op {
      gap: 5px;

      &:hover {
        cursor: pointer;
      }

      @extend .f-r-vc;

      span {
        font-size: $title-level-regular;
      }

      .op-icon {
        font-size: $dialog-header-op-icon-size;
      }
    }

    .confirm .op-icon {
      filter: $svg-business-color;
    }

    .close .op-icon {
      filter: $svg-danger-color;
    }

    .clear .op-icon {
      filter: $svg-warning-color;
      font-size: calc($dialog-header-op-icon-size - 2px);
    }
  }

  @extend .f-r-c-sb;
}

.footer {
  margin-top: 10px;
  justify-content: flex-end;

  @extend .f-r;
}

.content {
  min-height: 100px;
}

.error-msg {
  margin-bottom: 10px;
  word-break: break-word;
}
</style>
